import { useSelector, useDispatch } from 'react-redux';

import { setMultipleExpenseValues } from '../store/actions/expense';
import { selectExpenseStates } from '../store/selectors/expense.selector';
import { filterManuallyUpdatedFields, getRefinedAndHighestConfidenceData } from './expense.utils';
import { isNullOrEmpty } from './common.utils';

export const useUpdateExpenseFromReceipts = () => {
  const dispatch = useDispatch();
  const expenseStates = useSelector(selectExpenseStates);

  const updateExpenseWithReceiptsData = (receiptsList, actionType, subTab) => {
    const extractedData = getRefinedAndHighestConfidenceData(receiptsList);
    const filteredData = filterManuallyUpdatedFields(
      extractedData,
      expenseStates[actionType][subTab]?.manuallyUpdatedFields
    );

    if (isNullOrEmpty(filteredData)) {
      return;
    }

    dispatch(
      setMultipleExpenseValues({
        updatedFields: filteredData,
        actionType,
        subTab,
      })
    );
  };

  return { updateExpenseWithReceiptsData };
};
